import { useEffect, useState, useRef, useCallback } from "react";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Logo from "../../components/Logo";
import { useLocation } from "react-router-dom";
import LangChanger from "@layout/LangChanger";
import { LucideCircleUserRound } from "lucide-react";
import bg from "../../assets/Lilac Waves.mp4"
// import bg from "../../assets/videos/continiousWave.mp4";


const Main = ({ openModal }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const words = ["B2B", "intelligent", "réinventé"];
  const [index, setIndex] = useState(0);
  const videoRef = useRef(null);
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  // Detect touch device
  useEffect(() => {
    setIsTouchDevice('ontouchstart' in window || navigator.maxTouchPoints > 0);
  }, []);

  // Word animation
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % words.length);
    }, 2000);
    return () => clearInterval(interval);
  }, [words.length]);

  // Parallax effect (disabled on touch devices)
  useEffect(() => {
    if (isTouchDevice || !videoRef.current) return;

    let ticking = false;
    let animationFrameId = null;

    const handleScroll = () => {
      if (!ticking) {
        animationFrameId = requestAnimationFrame(() => {
          if (videoRef.current) {
            const translateY = window.scrollY * 0.3;
            videoRef.current.style.transform = `translate3d(0, ${translateY}px, 0)`;
          }
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    };
  }, [isTouchDevice]);

  const handleSolutionClick = () => {
    // Add your solution click handler
    console.log("Solutions clicked");
  };

  const handleStartClick = () => {
    // Add your start click handler
    console.log("Start now clicked");
  };

  return (
    <main className="position-relative" style={{ minHeight: '100vh', overflow: 'hidden' }}>
      <video
        ref={videoRef}
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
        className="position-absolute top-0 start-0"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
          willChange: "transform"
        }}
        aria-label="Background animation"
      >
        <source src={bg} type="video/mp4" />
      </video>

      <div
        className="position-relative w-100"
        style={{
          // background: "linear-gradient(to right, rgba(255,255,255,0.20), rgba(255,255,255,0))",
          zIndex: 1,
          minHeight: '100vh'
        }}
      >
        {/* Header */}
        <div className="py-5 px-2 px-md-10" style={{ height: '80px' }}>
          <Row className="align-items-center justify-content-between">
            <Col xs="4" xl="3">
              <Logo isWhite={true} />
            </Col>
            <Col xs="7">
              <div className="d-flex justify-content-end align-items-center gap-4 text-white fw-300" style={{ fontSize: "90%" }}>
                {/* <span className="d-md-block text-white">
                  <LangChanger location={location} t={t} />
                </span> */}
                {/* <button
                  className="btn-custom fw-bold d-none d-md-inline-block py-3 px-5 rounded-3 lh-1"
                  onClick={() => openModal("up")}
                  aria-label={t('register')}
                >
                  {t('register')}
                </button>
                <button
                  className="d-inline-block d-md-none bg-transparent border-0 text-white fs-4"
                  onClick={() => openModal("in")}
                  aria-label="User menu"
                >
                  <LucideCircleUserRound size={23} />
                </button> */}
                  <div className="d-flex justify-content-end align-items-center gap-4 fw-300"
               style={{ fontSize: "90%" }}>
            <span className="d-md-block text-white">
              <LangChanger location={location} t={t} />
            </span>

            <button
              className="d-none d-md-inline-block bg-blue text-white py-3 px-5 rounded-3 border border-white lh-1"
              onClick={() => openModal("in")}
            >
              {t('log_in')}
            </button>

            <button
              className="d-none d-md-inline-block bg-blue text-white bg-opacity-50 py-3 px-5 rounded-3 lh-1"
              onClick={() => openModal("up")}
            >
              {t('register')}
            </button>
              <button
                  className="d-inline-block d-md-none bg-transparent border-0 text-white fs-4"
                  onClick={() => openModal("in")}
                  aria-label="User menu"
                >
                  <LucideCircleUserRound size={23} />
                </button>
          </div>
              </div>
            </Col>
          </Row>
        </div>

        {/* Hero Content */}
        <div className="py-4 d-flex justify-content-center align-items-center" style={{
          minHeight: 'calc(100vh - 80px)', // 100vh - hauteur du header
          backgroundColor: 'transparent'
        }}>
          <div className="px-2 px-md-10 py-4">
            <div className="row">
              <div className="text-center d-flex flex-column align-items-center">
                <div className="d-inline-block text-white fw-bold text-uppercase fs-6 mt-4 glare-text px-4 py-2 rounded-pill border-1 border border-white" style={{
                      backgroundColor: "rgba(255, 255, 255, 0.1)", // 10% opacity
                      backdropFilter: "blur(10px)",
                      WebkitBackdropFilter: "blur(10px)", // Safari support
                      color: "#ffffff", // pure white text
                     
                      borderColor: "rgba(255, 255, 255, 0.7)" 
                    }}>
                  {t("l'intelligence au-delà du ")}<span className="element-slideLeftAnimation">{t("réel")}</span>
                </div>
                <h1 className="text-center fw-bold fs-1 fs-md-hero md:text-[3.5rem] leading-[1.1] mb-4 pb-4 pt-4 text-white" style={{ lineHeight: "1.1" }}>
                  {t("La technologie au service ")}{t("du voyage")}<br/>
                  <span><span className="text-tertiary element-slideUpAnimation"> {words[index]}.</span></span>
                </h1>
                <p className="text-center element-slideUpAnimation fs-5 fs-lg-4 text-white lh-base mb-4" style={{ opacity: 0.8, width:"750px" }}>
                  {t("Centralisez vos réservations, gérez vos partenaires et développez votre activité avec une interface intuitive, sécurisée et accessible partout dans le monde.")}
                </p>
                <div className="d-flex flex-column flex-md-row gap-4 justify-content-center  mt-4 pt-4">
                  <button
                    className="btn-slideLeftAnimation btn-first bg-blue text-white fs-6 fw-bold px-5 py-3 rounded-3"
                    onClick={handleSolutionClick}
                    aria-label="View solutions"
                  >
                    {t("Solutions")}
                  </button>


                  <button
                    className="btn-slideLeftAnimation fs-6 fw-bold px-5 py-3 rounded-3"
                    onClick={handleStartClick}
                    aria-label="Get started now"
                    style={{
                      backgroundColor: "rgba(255, 255, 255, 0.1)", // 10% opacity
                      backdropFilter: "blur(10px)",
                      WebkitBackdropFilter: "blur(10px)", // Safari support
                      color: "#ffffff", // pure white text
                      border: "none"
                    }}
                  >
                    {t("Commencer maintenant")}
                  </button>



                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Main;